/* eslint-disable */

<template>
    <v-container>
        <v-row class="flex-row" >
            <v-col cols="1" class="d-flex align-start justify-end order-2" >
                <div v-can="{obj_type:'client', action: 'edit'}">
                    <v-btn color="action" fab small @click.stop="updateRegistry" v-if="!edit"><v-icon class="ma-2">edit</v-icon></v-btn>
                    <span v-else>
                        <v-btn color="action" fab small @click.stop="restoreRegistry"><v-icon class="ma-2">cancel</v-icon></v-btn>
                    </span>
                </div>
            </v-col>
            <v-col cols="11" class="d-flex align-start justify-center order-1">
                <v-sheet width="100%" class="d-flex align-start justify-center fill-height">
                    <div v-if="!edit" class="d-flex flex-column flex-grow-1">
                        <div>
                            <b class="text-h6">{{ o_data.name }}</b><br/>
                            <i>P.IVA: <span class="text-subtitle-2">{{ o_data.piva }}</span></i> 
                            <i v-if="o_data.fiscal_code">, Codice Fiscale: <span class="text-subtitle-2">{{ o_data.fiscal_code }}</span></i><br/>
                            <span v-if="!is_organism">
                            <i v-if="o_data.pec" class="pr-2" >PEC: <span class="text-subtitle-2">{{ o_data.pec }}</span></i>
                            <i v-if="o_data.unique_code">Codice Univoco: <span class="text-subtitle-2">{{ o_data.unique_code }}</span></i><br/>
                            </span>
                            <i v-if="o_data.is_partner && use_partner"><span class="text-subtitle-2">partner di fatturazione/intermediario</span></i>
                        </div>
                        <div v-if="!is_organism" text-left mt-2>
                            <b class="text-subtitle-2">Sede Legale:</b>
                            <i v-if="o_data.registered_office && registered_location && !registered_location.dismissed"> {{registered_location.address}}, {{registered_location.addrNum}} - {{registered_location.city}} ({{registered_location.district}})</i>
                            <i v-else> - </i>
                        </div>
                    </div>
                    <div v-else class="d-flex flex-column flex-grow-1 flex-shrink-0">
                        <ClientRegistryEdit
                            class="d-flex"
                            ref="registry_form"
                            :o_data="o_data"
                            :is_organism="is_organism"
                            :locations="locations"
                        />
                        <v-alert v-if="!isValid" type="warning">
                            Attenzione alle possibili duplicazioni di Ragione sociale e partita IVA
                        </v-alert>
                        <span class="d-flex align-center justify-center flex-grow-1 flex-shrink-0">
                            <v-btn class="pa-2 mr-2" color="primary" @click.stop="updateRegistry">salva</v-btn>
                            <v-btn class="pa-2" color="action" @click.stop="restoreRegistry">annulla</v-btn>
                        </span>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
// import _ from 'lodash'

import {f_rules} from '../../utils/commonUtils'
import ClientRegistryEdit from './ClientRegistryEdit'

export default {
    components: {ClientRegistryEdit},
    props: {
        o_data: {
            type: Object,
            required: true
        },
        use_partner: {
            type: Boolean,
            required: false,
            default: true
        },
        is_organism: {
            type: Boolean,
            required: false,
            default: false
        },
        can_edit: {
            type: Boolean,
            required: false,
            default: true
        },
        locations: {
            type: Array,
            required: true
        },
        open_edit: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data(){
        return {
            rules: f_rules,
            edit: this.open_edit,
            registered_location: null,
            isValid: true
        }
    },
    async mounted() {
        await this.getRegisteredLocation()
    },
    beforeDestroy() {
        this.registered_location = null
    },
    methods: {
        async updateRegistry() {
            
            if (this.edit){
                this.isValid = await this.$refs.registry_form.isValid()
                // save
                if (this.isValid) {
                    let data = this.$refs.registry_form.getData()
                    this.$emit('registry_update', data)
                    this.edit = !this.edit
                } 
                // let res = await this.saveClient()
            } else {
                this.edit = !this.edit
            }    
        },
        restoreRegistry(){
            this.edit = false
        },
        async getRegisteredLocation() {
            if (this.o_data.registered_office) {
                this.registered_location = await this.$store.state.$pouch.get("registry", this.o_data.registered_office)
            }
        }
    },
    watch: {
        'o_data.registered_office': {
            async handler() {
                await this.getRegisteredLocation()
            }
        }
    },
}

</script>